export { default } from "./BigPrice";
